import React, { useContext, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import ScienceIcon from '@mui/icons-material/Science';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import toast from 'react-hot-toast';

import { AppContext } from '../../context/Context';
import { SocketContext } from '../../context/SocketContext';
import CashField from '../AvslutteSkiftet/CashField';

// Stage-only tool for seeding a shift with figures. Temporary — delete this file, its
// import in App.js and the testTransactions socket handler when it is no longer needed

// Same hostname test as the stage switcher in Login.js; localhost counts as a stage
const isStage = () => {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  return (
    host.includes('stage01') || host.includes('stage02') || host === 'localhost'
  );
};

// key must match LINES in backend/controllers/dev/testTransactions.js
const FIELDS = [
  { key: 'ch', label: 'CH' },
  { key: 'wg', label: 'WG' },
  { key: 'okd', label: 'OK D.' },
  { key: 'kiosk', label: 'Kiosk' },
  { key: 'card', label: 'Betal med kort' },
];

const EMPTY = { ch: '', wg: '', okd: '', kiosk: '', card: '' };

function TestTransactions() {
  const { hall, operator, session } = useContext(AppContext);
  const { socket } = useContext(SocketContext);

  const [open, setOpen] = useState(false);
  const [amounts, setAmounts] = useState(EMPTY);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (!socket) return;

    const handleResult = (data) => {
      setSending(false);
      if (!data || data.ok === false) {
        toast.error('Kunne ikke skrive testlinjene');
        return;
      }
      toast.success(`${data.inserted} linjer skrevet`);
      setAmounts(EMPTY);
      setOpen(false);
    };

    socket.on('testTransactions', handleResult);
    return () => socket.off('testTransactions', handleResult);
  }, [socket]);

  if (!isStage()) return null;

  const setAmount = (key, value) =>
    setAmounts((current) => ({ ...current, [key]: value }));

  const handleSend = () => {
    const filled = FIELDS.filter(({ key }) => amounts[key] !== '');
    if (!filled.length) {
      toast.error('Skriv minst ett beløp');
      return;
    }

    setSending(true);
    socket.emit('testTransactions', {
      action: 'testTransactions',
      bingoName: hall,
      operator,
      sessionID: session,
      amounts,
    });
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title="Testlinjer (kun stage)"
        style={{
          position: 'fixed',
          right: '18px',
          bottom: '18px',
          zIndex: 99999,
          width: '58px',
          height: '58px',
          borderRadius: '50%',
          border: '2px solid #fcad89',
          backgroundColor: '#151d3b',
          color: '#fcad89',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ScienceIcon style={{ fontSize: '28px' }} />
      </button>

      {open && (
        <div id="react-confirm-alert">
          <div className="react-confirm-alert-overlay">
            <div className="react-confirm-alert">
              <div
                className="react-confirm-alert-body modal-status"
                style={{ width: '760px' }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                    justifyContent: 'center',
                    mt: 3,
                  }}
                >
                  {FIELDS.map(({ key, label }) => (
                    <CashField
                      key={key}
                      label={label}
                      value={amounts[key]}
                      onChange={(value) => setAmount(key, value)}
                      width="220px"
                      fontSize="20px"
                      allowNegative
                    />
                  ))}
                </Box>

                <div className="react-confirm-alert-button-group">
                  <button
                    className="btn-custom-yes"
                    onClick={handleSend}
                    disabled={sending}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                    }}
                  >
                    <CheckCircleIcon style={{ fontSize: '1.2em' }} />
                    Skriv
                  </button>
                  <button
                    className="btn-custom-no"
                    onClick={() => setOpen(false)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                    }}
                  >
                    <CancelIcon style={{ fontSize: '1.2em' }} />
                    Avbryt
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default TestTransactions;
